import { render, staticRenderFns } from "./FormRadioDot.vue?vue&type=template&id=f09450c0&scoped=true&"
import script from "./FormRadioDot.vue?vue&type=script&lang=js&"
export * from "./FormRadioDot.vue?vue&type=script&lang=js&"
import style0 from "./FormRadioDot.vue?vue&type=style&index=0&id=f09450c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f09450c0",
  null
  
)

export default component.exports